angular.module('clientDashboardApp').directive('metricDelta', function ($location) {
  return {
    restrict: 'E',
    scope: {
      metric: '=',
      roundToInt: '=',
    },
    template: `
      <span 
          style="margin-left:5px;"
          ng-if="ratio !== undefined" 
          ng-class="{'text-danger' : ratio < 0, 'text-success' : ratio > 0}"
          >
          <span
            class="fa" ng-class="{'fa-arrow-down' : metric.delta < 0, 'fa-arrow-up' : metric.delta > 0}"></span>
          <span>{{deltaText}}</span>
      </span>
    `,
    controller: function ($scope) {

      $scope.roundToInt = $scope.roundToInt || false

      function initFields(metric) {
        delete $scope.deltaText
        delete $scope.ratio
        delete $scope.absRatio

        if (metric && metric.delta && $scope.metric.delta !== undefined) {
          $scope.ratio = metric.delta / (metric.value - metric.delta)
          if ($scope.ratio === Infinity || $scope.ratio === -Infinity) {
            delete $scope.ratio
          }
        }

        if ($scope.ratio !== undefined) {
          $scope.absRatio = Math.abs($scope.ratio);
          if ($scope.absRatio === 0) {
            $scope.deltaText = ''
          } else if ($scope.absRatio < 0.0001) {
            $scope.deltaText = $scope.roundToInt ? '' : ($scope.ratio < 0 ? '-0.01%' : '0.01%');
          } else if ($scope.absRatio < 0.001) {
            $scope.deltaText = $scope.roundToInt ? (Math.round(Math.round($scope.ratio * 10000) / 100)) + "%" : ((Math.round($scope.ratio * 10000) / 100) + "%");
          } else if ($scope.absRatio < 0.01) {
            $scope.deltaText = $scope.roundToInt ? Math.round((Math.round($scope.ratio * 1000) / 10)) + '%' : ((Math.round($scope.ratio * 1000) / 10) + "%");
          } else {
            $scope.deltaText = Math.round($scope.ratio * 100) + "%";
          }

          if ($scope.deltaText === '0%') {
            $scope.deltaText = '';
            if ($scope.roundToInt) {
              $scope.ratio = undefined;
            }
          }
        }
      }
      $scope.$watch('metric', (newMetric, oldMetric) => initFields(newMetric))
      initFields($scope.metric)

    }
  };
});
